export const SET_LOADING = 'src/store/sponsorType/SET_LOADING'
export const SET_SPONSOR_TYPE = 'src/store/sponsorType/SET_SPONSOR_TYPE'
